export default "__VITE_ASSET__0a0f9fa3__$_?react__"